import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Card = ({ value, label, color, t }) => (
  <Box sx={{
    padding: "14px 20px",
    background: t.surface,
    border: `1px solid ${t.border2}`,
    borderRadius: "6px",
    minWidth: "90px",
  }}>
    <Typography sx={{
      fontFamily: "'Inter', sans-serif",
      fontSize: "28px", fontWeight: 700,
      color: color, lineHeight: 1,
      letterSpacing: "-0.02em",
    }}>
      {value ?? "—"}
    </Typography>
    <Typography sx={{
      fontFamily: "'DM Mono', monospace",
      fontSize: "9px", letterSpacing: "0.12em",
      textTransform: "uppercase", color: t.text3,
      mt: "4px",
    }}>
      {label}
    </Typography>
  </Box>
);

const SummaryCards = ({ summary }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
      <Card value={summary?.inPool}      label="In Pool"      color={t.accent} t={t} />
      <Card value={summary?.fullyFree}   label="Fully Free"   color={t.accent} t={t} />
      <Card value={summary?.partial}     label="Partial"      color={t.gold}   t={t} />
      <Card value={summary?.freeFte}     label="Free FTE"     color={t.gold}   t={t} />
    </Box>
  );
};

export default SummaryCards;